import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import { Device, from } from '@helpers/media';
import { contentStyles, h3 } from '@helpers/typography';
import { m } from 'framer-motion';
import styled from 'styled-components';
const CardWrapper = styled.div ``;
const Container = styled.div `
  padding: ${fluid(20, 56)} ${fluid(12, 56)} ${fluid(20, 136)};
  background-color: ${brand.grey.lightest};
  border-radius: 0 0 ${fluid(5, 20)} ${fluid(5, 20)};
`;
const AccordionBtn = styled.button `
  ${ButtonReset};

  display: inline-flex;
  align-items: center;
  gap: 8px;
  background-color: ${brand.primary.purple.light};
  width: 100%;
  padding: 12px 36px 12px 7px;
  border-radius: ${fluid(5, 20)};
  position: relative;
  text-align: left;
  scroll-margin: var(--headerHeight, 0px) 0 0;

  @media ${from(Device.TabletLarge)} {
    display: none;
  }

  &.focus-ring {
    outline: auto;
    outline-offset: 3px;
    outline-width: 2px;
    outline-color: ${brand.primary.purple.light};
  }

  &[data-active='true'] {
    border-radius: ${fluid(5, 20)} ${fluid(5, 20)} 0 0;
  }
`;
const AccordionIcon = styled.div `
  width: 28px;
  height: 28px;
  background-color: ${brand.primary.blue.dark};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 28px;

  svg {
    width: 15px;
    height: 15px;
    color: ${brand.global.white};
  }
`;
const AccordionTitle = styled.span `
  ${fonts.intro};
  font-size: 20px;
  line-height: 26px;
  color: ${brand.global.white};
`;
const ChevronIcon = styled.div `
  position: absolute;
  right: 7px;
  top: 50%;
  transform: translateY(-50%);
  line-height: 0;

  svg {
    ${transition('transform')};

    color: ${brand.global.white};
    width: 24px;

    [data-active='true'] & {
      transform: rotate(180deg);
    }
  }
`;
const AccordionContent = styled(m.div) `
  overflow: hidden;
`;
const Title = styled.h3 `
  ${h3};
  font-size: ${fluid(18, 34)};
  line-height: ${fluid(24, 40)};
  margin-bottom: ${fluid(15, 46)};
`;
const ContentGrid = styled.div `
  display: grid;
  grid-template-columns: 1fr;
  gap: ${fluid(16, 32)} ${fluid(16, 100)};

  @media ${from(Device.TabletLarge)} {
    grid-template-columns: 1fr 1fr;
  }
`;
const Content = styled.div `
  ${contentStyles};
`;
const CtaWrapper = styled.div `
  margin-top: 12px;
`;
const List = styled.ul ``;
const ListItem = styled.li `
  display: grid;
  grid-template-columns: 1fr;
  gap: ${fluid(3, 12)};
  margin-bottom: ${fluid(24, 32)};

  &:last-of-type {
    margin-bottom: 0;
  }

  @media ${from(Device.TabletLarge)} {
    grid-template-columns: 60px auto;
  }
`;
const ListIcon = styled.div `
  width: ${fluid(40, 60)};
  height: ${fluid(40, 60)};
  background-color: ${brand.primary.purple.light};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: ${fluid(20, 30)};
    height: ${fluid(20, 30)};
    color: ${brand.global.white};
  }
`;
const ListContent = styled.div `
  ${contentStyles};
`;
const MembershipCardStyles = {
    AccordionBtn,
    AccordionContent,
    AccordionIcon,
    AccordionTitle,
    CardWrapper,
    ChevronIcon,
    Container,
    Content,
    ContentGrid,
    List,
    ListContent,
    ListIcon,
    ListItem,
    Title,
    CtaWrapper,
};
export default MembershipCardStyles;
